module.exports = "/_next/static/images/collaborate-mobile@2x-c4eed209c3434d614704e10a23fb13a7.png";